import React from 'react';
import bem from 'utils/bem';
import Icon from 'components/Icon';
import links from './links';

import './index.sass';

const { cnBlock } = bem('social-icon')

const SocialIcon = ({className, name, href, mod = 'green'}) => (
    <a className={cnBlock(className, mod)} href={href} target='_blank'><Icon name={name}/></a>
)

const TelegramIcon = (props) => <SocialIcon {...props} name={'telegram-logo'} href={links['telegram'].link } />;
const YoutubeIcon = (props) => <SocialIcon {...props} name={'youtube-logo'} href={links['youtube'].link } />;
const PodcastIcon = (props) => <SocialIcon {...props} name={'podcasts'} href={links['podcast'].link } />;

export {
    TelegramIcon,
    YoutubeIcon,
    PodcastIcon
}
